import { default as index3nMWkO7rnhMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue?macro=true";
import { default as OverviewvFCdM6DYIOMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue?macro=true";
import { default as ProductInfoPanelHxsLMtFXVZMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue?macro=true";
import { default as indexNWCMcoQB7dMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue?macro=true";
import { default as accountUnfNbB6nPVMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/account.vue?macro=true";
import { default as indexFmDrVpaOLJMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/index.vue?macro=true";
import { default as login7boxDD7VwfMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/login.vue?macro=true";
import { default as payFPs1ir9KtGMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/pay.vue?macro=true";
import { default as personal_45centerpsc8oM1ot3Meta } from "/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue?macro=true";
import { default as cloudmeKHk8tQgFMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue?macro=true";
import { default as devicegfTWx9A3QAMeta } from "/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue?macro=true";
export default [
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/tw/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___tw",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___tw",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___tw",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___tw",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___en",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___en",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___en",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___en",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/fr/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___fr",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___fr",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___fr",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___fr",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/ms/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___ms",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___ms",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___ms",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___ms",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/de/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___de",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___de",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___de",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___de",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/it/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___it",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___it",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___it",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___it",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/es/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___es",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___es",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___es",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___es",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/jp/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___jp",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___jp",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___jp",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___jp",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/kr/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___kr",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___kr",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___kr",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___kr",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/th/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___th",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___th",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___th",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___th",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/br/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___br",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___br",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___br",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___br",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/id/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___id",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___id",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___id",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___id",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/vn/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___vn",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___vn",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___vn",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___vn",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/ru/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___ru",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___ru",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___ru",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___ru",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/tr/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___tr",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___tr",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___tr",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___tr",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: accountUnfNbB6nPVMeta?.name,
    path: "/sa/account",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account.vue"),
    children: [
  {
    name: "account___sa",
    path: "",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/index.vue")
  },
  {
    name: "account-order-center-components-Overview___sa",
    path: "order-center/components/Overview",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/Overview.vue")
  },
  {
    name: "account-order-center-components-ProductInfoPanel___sa",
    path: "order-center/components/ProductInfoPanel",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/components/ProductInfoPanel.vue")
  },
  {
    name: "account-order-center___sa",
    path: "order-center",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/account/order-center/index.vue")
  }
]
  },
  {
    name: "index___tw",
    path: "/tw",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___jp",
    path: "/jp",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___kr",
    path: "/kr",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___br",
    path: "/br",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___vn",
    path: "/vn",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "index___sa",
    path: "/sa",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/index.vue")
  },
  {
    name: "login___tw",
    path: "/tw/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___ms",
    path: "/ms/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___jp",
    path: "/jp/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___kr",
    path: "/kr/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___th",
    path: "/th/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___br",
    path: "/br/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___id",
    path: "/id/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___vn",
    path: "/vn/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "login___sa",
    path: "/sa/login",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/login.vue")
  },
  {
    name: "pay___tw",
    path: "/tw/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___en",
    path: "/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___fr",
    path: "/fr/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___ms",
    path: "/ms/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___de",
    path: "/de/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___it",
    path: "/it/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___es",
    path: "/es/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___jp",
    path: "/jp/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___kr",
    path: "/kr/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___th",
    path: "/th/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___br",
    path: "/br/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___id",
    path: "/id/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___vn",
    path: "/vn/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___ru",
    path: "/ru/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___tr",
    path: "/tr/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "pay___sa",
    path: "/sa/pay",
    meta: payFPs1ir9KtGMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/pay.vue")
  },
  {
    name: "personal-center___tw",
    path: "/tw/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___en",
    path: "/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___fr",
    path: "/fr/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___ms",
    path: "/ms/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___de",
    path: "/de/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___it",
    path: "/it/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___es",
    path: "/es/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___jp",
    path: "/jp/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___kr",
    path: "/kr/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___th",
    path: "/th/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___br",
    path: "/br/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___id",
    path: "/id/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___vn",
    path: "/vn/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___ru",
    path: "/ru/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___tr",
    path: "/tr/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "personal-center___sa",
    path: "/sa/personal-center",
    meta: personal_45centerpsc8oM1ot3Meta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/personal-center.vue")
  },
  {
    name: "purchase-cloud___tw",
    path: "/tw/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___en",
    path: "/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___fr",
    path: "/fr/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___ms",
    path: "/ms/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___de",
    path: "/de/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___it",
    path: "/it/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___es",
    path: "/es/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___jp",
    path: "/jp/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___kr",
    path: "/kr/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___th",
    path: "/th/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___br",
    path: "/br/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___id",
    path: "/id/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___vn",
    path: "/vn/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___ru",
    path: "/ru/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___tr",
    path: "/tr/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-cloud___sa",
    path: "/sa/purchase/cloud",
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/cloud.vue")
  },
  {
    name: "purchase-device___tw",
    path: "/tw/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___en",
    path: "/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___fr",
    path: "/fr/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___ms",
    path: "/ms/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___de",
    path: "/de/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___it",
    path: "/it/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___es",
    path: "/es/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___jp",
    path: "/jp/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___kr",
    path: "/kr/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___th",
    path: "/th/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___br",
    path: "/br/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___id",
    path: "/id/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___vn",
    path: "/vn/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___ru",
    path: "/ru/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___tr",
    path: "/tr/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  },
  {
    name: "purchase-device___sa",
    path: "/sa/purchase/device",
    meta: devicegfTWx9A3QAMeta || {},
    component: () => import("/root/workspace/ldshop_vest/apps/vest/pages/purchase/device.vue")
  }
]